'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('./config.js');

Object.defineProperty(exports, 'configureFlashMessages', {
  enumerable: true,
  get: function get() {
    return _config.configureFlashMessages;
  }
});
Object.defineProperty(exports, 'getConfig', {
  enumerable: true,
  get: function get() {
    return _config.getConfig;
  }
});

var _service = require('./service.js');

Object.defineProperty(exports, 'addError', {
  enumerable: true,
  get: function get() {
    return _service.addError;
  }
});
Object.defineProperty(exports, 'addWarning', {
  enumerable: true,
  get: function get() {
    return _service.addWarning;
  }
});
Object.defineProperty(exports, 'addSuccess', {
  enumerable: true,
  get: function get() {
    return _service.addSuccess;
  }
});
Object.defineProperty(exports, 'addInfo', {
  enumerable: true,
  get: function get() {
    return _service.addInfo;
  }
});
Object.defineProperty(exports, 'addApocalypse', {
  enumerable: true,
  get: function get() {
    return _service.addApocalypse;
  }
});
Object.defineProperty(exports, 'addFlashMessageOfType', {
  enumerable: true,
  get: function get() {
    return _service.addFlashMessageOfType;
  }
});

var _flashMessageReducer = require('./flash-message-reducer.js');

Object.defineProperty(exports, 'flashMessage', {
  enumerable: true,
  get: function get() {
    return _flashMessageReducer.flashMessage;
  }
});
Object.defineProperty(exports, 'addFlashMessage', {
  enumerable: true,
  get: function get() {
    return _flashMessageReducer.addFlashMessage;
  }
});
Object.defineProperty(exports, 'removeFlashMessage', {
  enumerable: true,
  get: function get() {
    return _flashMessageReducer.removeFlashMessage;
  }
});